import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
} from "react-bootstrap";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log("Form submitted:", formData);
    setShowAlert(true);
    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });

    setTimeout(() => setShowAlert(false), 5000);
  };

  const contactInfo = [
    {
      icon: "📧",
      title: "Email",
      value: "info@womenshgenterprises.com",
      description: "Send us your queries anytime",
    },
    {
      icon: "📞",
      title: "Phone",
      value: "+91-7397382501",
      description: "Call us during business hours",
    },
    {
      icon: "📍",
      title: "Address",
      value:
        "73/3, Ground Floor, West Jones Road, West Saidapet, Chennai - 600 015",
      description: "Visit us at our main office",
    },
    {
      icon: "🕒",
      title: "Business Hours",
      value: "Mon-Sat: 9:00 AM - 6:00 PM",
      description: "We are here to help you",
    },
  ];

  const officeLocations = [
    {
      name: "Main Headquarters",
      address: "Chennai Saidapet, Tamil Nadu",
      phone: "+91-7397382501",
      email: " info@womenshgenterprises.com",
      services: ["Administration", "Training", "Technology Support"],
    },
    {
      name: "Koorum Collection Center",
      address: "Koorum Village, Tamil Nadu",
      phone: "+91-XXXXXXXXX",
      email: "info@womenshgenterprises.com",
      services: ["Milk Collection", "Quality Testing", "Farmer Support"],
    },
    {
      name: "Thimmasamuthiram  Processing Unit",
      address: "Thimmasamuthiram Village, Tamil Nadu",
      phone: "+91-XXXXXXXXX",
      email: "info@womenshgenterprises.com",
      services: ["Milk Processing", "Product Development", "Quality Control"],
    },
  ];

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section
        className="py-5 text-white hero_sec"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">Contact Us</h1>
              <p className="fs-5">
                Get in touch with WiSE for partnerships, Enquiries, or support
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Form & Info */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mb-5">
              <Card className="border-0 shadow-lg contact-form">
                <Card.Body>
                  <h2 className="fw-bold mb-4">Send us a Message</h2>
                  {showAlert && (
                    <Alert variant="success" className="mb-4">
                      Thank you for your message! We will get back to you within
                      24 hours.
                    </Alert>
                  )}
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Full Name *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="border-0 bg-light p-3"
                            placeholder="Enter your full name"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Email Address
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="border-0 bg-light p-3"
                            placeholder="Enter your email (optional)"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Phone Number *
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            className="border-0 bg-light p-3"
                            placeholder="Enter your phone number"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            Subject
                          </Form.Label>
                          <Form.Select
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            className="border-0 bg-light p-3"
                          >
                            <option value="">Select a subject</option>
                            <option value="partnership">
                              Partnership Inquiry
                            </option>
                            <option value="product">Product Information</option>
                            <option value="training">Training Programs</option>
                            <option value="support">Technical Support</option>
                            <option value="other">Other</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="mb-4">
                      <Form.Label className="fw-semibold">Message *</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        className="border-0 bg-light p-3"
                        placeholder="Please describe your inquiry or feedback..."
                      />
                    </Form.Group>
                    <Button
                      type="submit"
                      className="btn-primary-custom btn-lg px-5"
                    >
                      Send Message
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4}>
              <h3 className="fw-bold mb-4">Contact Information</h3>
              {contactInfo.map((info, index) => (
                <Card
                  key={index}
                  className="border-0 shadow-sm mb-3 hover-lift"
                >
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center">
                      <div className="me-3" style={{ fontSize: "2rem" }}>
                        {info.icon}
                      </div>
                      <div>
                        <h6 className="fw-bold mb-1">{info.title}</h6>
                        <p className="text-primary fw-semibold mb-1">
                          {info.value}
                        </p>
                        <small className="text-muted">{info.description}</small>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Office Locations */}
      <section
        className="section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Our Locations</h2>
              <p className="fs-5 text-muted">
                Visit us at any of our offices and collection centers
              </p>
            </Col>
          </Row>
          <Row>
            {officeLocations.map((location, index) => (
              <Col lg={4} key={index} className="mb-4">
                <Card className="border-0 shadow card-hover h-100">
                  <Card.Body className="p-4">
                    <Card.Title className="fw-bold h5 text-primary">
                      {location.name}
                    </Card.Title>
                    <div className="mb-2">
                      <small className="text-muted">
                        📍 {location.address}
                      </small>
                    </div>
                    <div className="mb-2">
                      <small className="text-muted">📞 {location.phone}</small>
                    </div>
                    <div className="mb-3">
                      <small className="text-muted">📧 {location.email}</small>
                    </div>
                    {/* Only show "Sales Available:" for sections other than Koorum & Thimmasamuthiram */}
                    <h6 className="fw-bold">
                      {location.name !== "Koorum Collection Center" &&
                      location.name !== "Thimmasamuthiram  Processing Unit"
                        ? "Sales Available:"
                        : ""}
                    </h6>
                    <ul className="list-unstyled">
                      {location.services.map((service, idx) => (
                        <li key={idx} className="small text-success mb-1">
                          ✓ {service}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Map Section */}
      <section className="py-5">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-4">
              <h2 className="display-5 fw-bold mb-3">Find Us</h2>
              <p className="text-muted">Our main headquarters location</p>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="bg-light p-5 rounded shadow text-center">
                <div className="mb-3" style={{ fontSize: "3rem" }}>
                  🗺️
                </div>
                <h5 className="fw-bold">Interactive Map</h5>
                <p className="text-muted">
                  Map integration will be available here showing our exact
                  location
                  <br />
                  <small>WiSE Headquarters, Chennai, Tamil Nadu, India</small>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ Quick Links */}
      <section
        className="py-5 text-white"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">Quick Help</h2>
              <p className="fs-5 mb-4">
                Looking for quick answers? Check our frequently asked questions
              </p>
              <div className="d-flex justify-content-center gap-3">
                <Button variant="light" size="lg" className="px-4">
                  View FAQ
                </Button>
                <Button variant="outline-light" size="lg" className="px-4">
                  Schedule Call
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Contact;
